<template>
  <div v-if="promoBannerPresent" class="plan-block promo-banner-container">
    <a :href="link">
      <img :src="require(`../assets/resorts/${imgSrc}`)" :alt="title" class="hide-tablet" />
      <img :src="require(`../assets/resorts/${imgMobileSrc}`)" :alt="title" class="show-tablet" />
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PromoBanner',
  computed: {
    ...mapState(['promoBanner']),
    promoBannerPresent() {
      if (!this.promoBanner.imgUrl) { return; }

      return true;
    },
    imgSrc() {
      return this.promoBanner.imgUrl;
    },
    imgMobileSrc() {
      return this.promoBanner.imgMobileUrl;
    },
    link() {
      return this.promoBanner.url;
    },
    title() {
      return this.promoBanner.title;
    },
  },
};
</script>

<style lang="scss" scoped>
  .promo-banner-container {
    line-height: 1;
    img {
      width: 100%;
    }
  }
</style>
